import React, { FC } from 'react';
import MuiFade, { FadeProps as MuiFadeProps } from '@material-ui/core/Fade';
import { Uds } from '../../types';

export type FadeProps = Uds<MuiFadeProps & {}>;

export const Fade: FC<React.PropsWithChildren<FadeProps>> = ({ dataTest, ...props }) => (
  <MuiFade data-test={dataTest} {...props} />
);
